// Override Settings
var bcSfSearchSettings = {
  search: {
    // suggestionMode: 'test',
    // suggestionPosition: 'left'
  }
};

// Customize style of Suggestion box
BCSfFilter.prototype.customizeSuggestion = function(suggestionElement, searchElement, searchBoxId) {};

// Build number of Search result
// BCSfFilter.prototype.buildSearchResultNumber = function(data) {
//   var content = '';
//   var searchTerm = this.escape(this.getSearchTerm());
//   if (searchTerm != null) {
//       var content = bcSfFilterConfig.label.search_result_number_other;
//       if (data.total_product <= 1) {
//           var content = bcSfFilterConfig.label.search_result_number_one;
//       }
//       content = content.replace(/{{ count }}/g, data.total_product).replace(/{{ terms }}/g, searchTerm);
//   }
//   jQ('.' + this.class.searchResultNumber).html(content);
// };

// Override their method to change what gets displayed
BCSfFilter.prototype.buildSuggestionProductList = function(a, b, c, d, e) {
  var f = "";

  f += this.buildSuggestionHeader(d.label, "product");

  var g = this.buildSuggestionDidYouMean(a, e, c);

  if ("" != g && (f += '<li class="' + this.class.searchSuggestionItem + ' bc-sf-search-suggestion-dym" aria-label="Did you mean">' + g + "</li>"), Object.keys(b).length > 0)
      for (var h = 0, i = 0; i < b.length && h < d.number; i++) {
          var j = b[i]
          var k = this.customizeSuggetionProductTitle(j.title, a, b);

          k = this.highlightSuggestionResult(k, a);

          var l = this.buildProductItemUrl(j, !1);
          var m = j.images_info.length > 0 ? this.optimizeImage(j.images_info[0].src, "200x") : bcSfFilterConfig.general.no_image_url;
          var n = null !== j.skus && j.skus.length > 0 ? j.skus[0] : "";
		  if(n.includes("PRESALE")){ n = n.split('|')[0] }
          var o = this.class.searchSuggestion;
          var p = this.getSettingValue("search.openProductNewTab") ? 'target="_blank"' : "";

          f += '<li class="' + this.class.searchSuggestionItem + " " + this.class.searchSuggestionItem + '-product" aria-label="' + this.escape(d.label) + ": " + this.escape(j.title) + '">',
          f += '<a href="' + l + '" ' + p + ">", this.getSettingValue("search.showSuggestionProductImage") && (f += '<div class="' + o + '-left"><img src="' + m + '" /></div>'),
          f += '<div class="' + o + '-right">',
          f += '<div class="' + o + '-product-title">' + k + "</div>",
            (f += '<div class="' + o + '-product-type">' + j.product_type + "</div>"),
            this.getSettingValue("search.showSuggestionProductSku") && (f += '<div class="' + o + '-product-sku">SKU: ' + n + "</div>"),
            f += this.buildSuggestionProductPrice(j),
          f += "</div>",
          f += "</a>",
          f += "</li>",
          h++
      }
  return f
}

BCSfFilter.prototype.buildSuggestionCollection = function (a, b, c, d, e) {
  var hiddenCollections = window.hiddenSearchCollections;
  var hasResult = false;
  var template = '';

  if (b.length) {
    template += '<li class="bc-sf-search-suggestion-header-collection bc-sf-search-suggestion-header" aria-label="' + d.label + '">' + d.label + '</li>';

    for (var i = 0, len = b.length; i < len; i++) {
      if (hiddenCollections.indexOf(b[i].handle) < 0) {
        template += '<li class="bc-sf-search-suggestion-item bc-ui-item ui-menu-item" data-label="' + b[i].id + '" data-value="' + b[i].title + '" aria-label="' + d.label + ': ' + b[i].title + '">';
        template += '<a href="/' + d.type + '/' + b[i].handle + '" tabindex="-1" class="ui-menu-item-wrapper"><b>' + b[i].title + '</b></a>';
        template += '</li>';
        hasResult = true;
      }
    }
  }

  return hasResult ? template : ''
}
